import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';
import { hueClass, type Hue } from '@/lib/hue';

/** An invitation, not an apology: a tinted icon square, the name of the space, one action. */
export function EmptyState({
  icon: Icon,
  hue = 'gray',
  title,
  description,
  action,
  secondary,
  className,
  bordered = false,
}: {
  icon?: LucideIcon;
  hue?: Hue;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  secondary?: ReactNode;
  className?: string;
  bordered?: boolean;
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-1 px-4 py-12 text-center',
        bordered && 'mx-auto my-8 max-w-sm rounded-xl border border-dashed border-border-strong px-6 py-7',
        className,
      )}
    >
      {Icon && (
        <span className={cn('mb-1.5 grid size-10 place-items-center rounded-lg tinted', hueClass(hue))}>
          <Icon aria-hidden className="size-5" strokeWidth={1.5} />
        </span>
      )}
      <p className="text-md font-semibold text-fg">{title}</p>
      {description && <p className="max-w-sm text-base text-fg-muted">{description}</p>}
      {(action ?? secondary) && (
        <div className="mt-3 flex items-center gap-2">
          {action}
          {secondary}
        </div>
      )}
    </div>
  );
}
